var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.57143C5 4.41988 5.05673 4.27453 5.15771 4.16737C5.25869 4.0602 5.39565 4 5.53846 4H18.4615C18.6043 4 18.7413 4.0602 18.8423 4.16737C18.9433 4.27453 19 4.41988 19 4.57143V6.85715C19 6.99808 18.9509 7.13402 18.8622 7.23887L14.1538 12.7909V18.2858C14.1538 18.4056 14.1181 18.5225 14.0521 18.6197C13.986 18.7169 13.8927 18.7896 13.7855 18.8275L10.5548 19.9703C10.4739 19.9989 10.3877 20.0067 10.3034 19.9931C10.2191 19.9794 10.1391 19.9447 10.0699 19.8918C10.0007 19.839 9.94433 19.7694 9.90543 19.6888C9.86654 19.6083 9.84622 19.5191 9.84615 19.4286V12.7909L5.13785 7.23887C5.04912 7.13402 5.00002 6.99808 5 6.85715V4.57143Z",
    fill: "#2773FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/_filter.9692081de28576a4ba1afaed06a76de1.svg";
export { ForwardRef as ReactComponent };